var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
// Utils
import { getArrayOfValues } from './getArrayOfValues';
import { isObject } from '../checks';
import { isPrimitive } from '../../others';
var hasReachedTargetObject = function (pathToTarget, currentIndex, lastIndex) { return pathToTarget.length === 0 || currentIndex === lastIndex; };
/**
 * @description Collect specific property values from object recursively
 *
 * @param {object} obj - object to be operated on
 * @param {string[]} keysToFind - keys to find a target path
 * @param {PathArray} targetPath - use this to traverse deeper in to the object
 * @param {number} currentIndex - current index to the target path
 *
 * @example
 * getArrayOfValuesFromObjectRecursively({id: 1, name: 'abc'}, ['id']);
 * // return [{ id: 1 }]
 *
 * getArrayOfValuesFromObjectRecursively({child: {id: 2}}, ['child', 'id']);
 * // return [{ id: 2 }]
 *
 * getArrayOfValuesFromObjectRecursively({childArray: [{id: 2}, {id: 3}]}, ['child', 'id']);
 * // return [{ id: 2 }, { id: 3 }]
 *
 * getArrayOfValuesFromObjectRecursively(
 * {
 *   child: {
 *     id: 1,
 *     grandChild: [
 *       {id: 2},
 *       {id: 3},
 *       {id: 2}
 *     ]
 *   }
 * },
 * ['child', 'grandChild', 'id']
 * );
 * // return [{ id: 2 }, { id: 3 }, { id: 2 }]
 *
 * getArrayOfValuesFromObjectRecursively(
 * {
 *   arrayChild: [
 *     {
 *       arrayGrandChild: [
 *         {
 *           arrayGrandGrandChild:[
 *             {id: 10},
 *             {id: 11}
 *           ]
 *         }
 *       ],
 *     },
 *     {
 *       arrayGrandChild: [
 *         {
 *           arrayGrandGrandChild:[
 *             {id: 10},
 *             {id: 12}
 *           ]
 *         },
 *         {
 *           arrayGrandGrandChild:[
 *             {id: 14}
 *           ]
 *         }
 *       ],
 *     },
 *   ],
 * },
 * ['arrayChild', 'arrayGrandChild', 'arrayGrandGrandChild', 'id']
 * );
 * // return [{ id: 10 }, { id: 11 }, { id: 10 }, { id: 12 }, { id: 14 }]
 *
 * @returns {any[]}
 */
export var getArrayOfValuesFromObjectRecursively = function (obj, keysToFind, targetPath, currentIndex) {
    if (targetPath === void 0) { targetPath = []; }
    if (currentIndex === void 0) { currentIndex = 0; }
    if (isPrimitive(obj))
        return [];
    var lastIndex = targetPath.length;
    var currentPath = targetPath[currentIndex];
    if (hasReachedTargetObject(targetPath, currentIndex, lastIndex)) {
        return getArrayOfValues(obj, keysToFind);
    }
    if (Array.isArray(obj)) {
        return obj.reduce(function (resultArray, currentObj) {
            if (!isObject(currentObj)) {
                return resultArray;
            }
            // Go deeper on each obj
            return __spread(resultArray, getArrayOfValuesFromObjectRecursively(currentObj[currentPath], keysToFind, targetPath, currentIndex + 1));
        }, []);
    }
    // Go deeper
    return getArrayOfValuesFromObjectRecursively(obj[currentPath], keysToFind, targetPath, currentIndex + 1);
};
//# sourceMappingURL=getArrayOfValuesFromObjectRecursively.js.map